module.exports = __webpack_public_path__ + "img/status-created.28b89db9.svg";